module.exports = __webpack_public_path__ + "static/img/blog-img3.4ededfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blog-img3.jpg
// module id = YPcd
// module chunks = 1